import React, {useState} from "react";
import signup_otp from "assets/Login/signup-otp.png";
import Button from "components/molecules/Button";
import Form from "components/molecules/Form/Form";
import {useForm} from "components/molecules/Form";
import Heading from "components/atoms/Auth/Heading";
import {useNavigate} from "react-router-dom";
import OtpInput from "components/molecules/Otp";
import OnBoardingLayout from "components/atoms/Auth/OnBoardingLayout";
import authService from "services/authService";
import Toast from "components/molecules/Toast";
import {setCookie} from "helpers/common";
import {useAuthContext} from "Context/authContext";

const SignUpVerifyOtp = () => {
    const [form] = useForm();
    const navigate = useNavigate();
    const [otpValue, setOtpValue] = useState("");
    const email = sessionStorage.getItem("userEmail");
    const [loading, setLoading] = useState(false);
    const {setIsLoggedIn} = useAuthContext();

    async function handleSubmit() {
        try {
            setLoading(true);
            const res = await authService.verifyOtp({email, otp: otpValue});
            Toast({type: "success", message: res.message});
            setCookie(process.env.REACT_APP_FOODIE_TOKEN_COOKIE, res?.token);
            navigate("/business-setup");
            setLoading(false);
            setIsLoggedIn(true);
        } catch (err) {
            setLoading(false);
            Toast({type: "error", message: err.message});
        }
    }
    async function resendOtp() {
        try {
            const res = await authService.resentOtp({email});
            Toast({type: "success", message: res.message});
        } catch (err) {
            Toast({type: "error", message: err.message});
        }
    }
    return (
        <>
            <OnBoardingLayout img={signup_otp}>
                <Heading
                    heading="Verify your email"
                    para={`Please check our inbox and tap the link in the email we’ve just sent to: ${email}`}
                />
                <Form form={form} onSubmit={handleSubmit}>
                    <OtpInput
                        numInputs={4}
                        setOtpValue={value => setOtpValue(value.join(""))}
                        onChange={e => console.log(e)}
                        inputBg={"transparent"}
                        handleResentOtp={() => resendOtp()}
                    />
                    <Button lg type="submit" loader={loading}>
                        Verify now
                    </Button>
                </Form>
            </OnBoardingLayout>
        </>
    );
};

export default SignUpVerifyOtp;
